export { TermLink } from './term-link.component';
